import { useEffect, useRef } from "react";
import { Search, X } from "lucide-react";

/**
 * Focused with "/" from anywhere on the page, cleared with Escape — with ten
 * categories on screen, typing beats scrolling.
 */
export default function SearchBar({ value, onChange }) {
  const inputRef = useRef(null);

  useEffect(() => {
    const onKeyDown = (e) => {
      const typingElsewhere = /^(INPUT|TEXTAREA|SELECT)$/.test(document.activeElement?.tagName ?? "");

      if (e.key === "/" && !typingElsewhere) {
        e.preventDefault();
        inputRef.current?.focus();
      }
      if (e.key === "Escape" && document.activeElement === inputRef.current) {
        onChange("");
        inputRef.current?.blur();
      }
    };

    window.addEventListener("keydown", onKeyDown);
    return () => window.removeEventListener("keydown", onKeyDown);
  }, [onChange]);

  return (
    <div className="group relative">
      <Search className="pointer-events-none absolute left-3.5 top-1/2 h-4 w-4 -translate-y-1/2 text-white/40 transition-colors group-focus-within:text-white/70" />

      <input
        ref={inputRef}
        type="search"
        value={value}
        onChange={(e) => onChange(e.target.value)}
        placeholder="Search apps…"
        aria-label="Search apps"
        className="w-full rounded-xl border border-white/10 bg-white/[0.06] py-2.5 pl-10 pr-16 text-sm text-white
          placeholder-white/35 shadow-sm backdrop-blur transition
          hover:bg-white/[0.09] focus:border-white/20 focus:bg-white/[0.1] focus:outline-none focus:ring-2 focus:ring-white/15
          [&::-webkit-search-cancel-button]:hidden"
      />

      {value ? (
        <button
          type="button"
          onClick={() => onChange("")}
          aria-label="Clear search"
          className="absolute right-3 top-1/2 -translate-y-1/2 rounded-md p-1 text-white/45 transition-colors hover:bg-white/10 hover:text-white"
        >
          <X className="h-4 w-4" />
        </button>
      ) : (
        <kbd className="pointer-events-none absolute right-3 top-1/2 hidden -translate-y-1/2 rounded border border-white/15 bg-white/5 px-1.5 py-0.5 font-sans text-[11px] text-white/35 sm:block">
          /
        </kbd>
      )}
    </div>
  );
}
